<template>
  <form
    v-if="!requestSuccess"
    class="animated fadeIn"
    @submit.prevent="submit()">
    <h1>Change Password</h1>
    <small
      v-if="$route.query.changeInitRegPass"
      class="text-danger">Please change your One Time Password (OTP) immediately.</small>
    <hr >
    <div class="form-group mb-3">
      <label for="oldPassword">Old Password</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="icon-lock"/></span>
        </div>
        <input
          id="oldPassword"
          v-model="passwordModel.oldPass"
          type="password"
          class="form-control"
          placeholder="New Password"
          required>
      </div>
    </div>
    <div class="form-group mb-3">
      <label for="newPassword">New Password</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="icon-lock"/></span>
        </div>
        <input
          id="newPassword"
          v-model="passwordModel.newPass"
          type="password"
          class="form-control"
          placeholder="New Password"
          required>
      </div>
    </div>
    <div class="form-group mb-3">
      <label for="newPasswordConfirm">Confirm New Password</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="icon-lock"/></span>
        </div>
        <input
          id="newPasswordConfirm"
          v-model="passwordModel.newPassConfirm"
          type="password"
          class="form-control"
          placeholder="Confirm Password"
          required>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <small
          v-show="isError"
          class="text-danger">{{ msg.errorMsg }}</small>
        <small
          v-show="requestSuccess"
          class="text-success">{{ msg.successMsg }}</small>
      </div>
    </div>
    <div class="row">
      <div
        v-show="!requestSuccess"
        class="col">
        <button
          :disabled="isFetching"
          type="submit"
          class="btn btn-primary px-4">Change Password</button>
      </div>
    </div>
  </form>
  <div
    v-else-if="requestSuccess"
    class="success-img text-center text-success px-3 py-3 my-4">
    <i class="fa fa-check-circle-o fa-4x" />
    <h5 class="mt-2">{{ msg.successMsg }}</h5>
    <router-link
      :to="{ name: 'Login', query: {'appId': appId} }"
      class="mx-3 btn btn-default">Back to Login</router-link>
  </div>
</template>

<script>
import auth from '@/services/auth.service'
import AES from 'crypto-js/aes'
import encUtf8 from 'crypto-js/enc-utf8'

export default {
  name: 'ChangePassword',
  data () {
    return {
      passwordModel: Object,
      msg: Object,
      isFetching: false,
      isError: false,
      requestSuccess: false,
      token: '',
      appId: ''
    }
  },
  mounted () {
    this.token = this.$route.query.hash
    let normalizedToken = this.token.replace(/ /g, '+');
    let decryptedBytes = AES.decrypt(normalizedToken, process.env.VUE_APP_PASSPHRASE)
    this.token = decryptedBytes.toString(encUtf8)
    this.appId = this.$route.query.appId
  },
  methods: {
    submit () {
      if (this.passwordModel.newPass !== this.passwordModel.newPassConfirm) {
        this.isError = true;
        this.msg.errorMsg = 'New password and confirmation password do not match'
      } else {
        this.isError = false
        this.requestSuccess = false
        this.isFetching = true
        auth.changePassword(this.passwordModel, this.token, this.$route.query.changeInitRegPass).then(
          (resp) => {
            this.isFetching = false
            this.requestSuccess = true
            this.msg.successMsg = resp.data.msgContent
            // this.$router.push({ path: 'login', query: { appId: this.appId }})
          },
          (err) => {
            this.isFetching = false
            this.isError = true
            this.msg.errorMsg = err.response.data.msgContent
          }
        )
      }
    }
  },
}
</script>
